import Vue from 'vue';
import Logo from "./Logo";

Vue.component('logo', Logo);

const LogoVM = Vue.extend(Logo);

// Replace static logos:
$('.kunst-logo').not('js-kunst-logo').each(function () {
    const vm = new LogoVM();
    vm.$mount(this);
});
